<template>

<LayoutContainer :columns="columnSplits">

<template slot="header">
    <div class="pa-2 red--text red lighten-4" v-if="isMaster">
        Warning: you're in {{officeName}} master. Changes affect all client files.
        <a style="text-decoration:none;color:red;" href="/templates" target="_blank">Open Doc Templates</a>
    </div>

    <v-toolbar dark dense class="primary">
        <v-btn @click.native="$router.push('/home')" icon>
            <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-toolbar-title @click="setSpecialTab('home')"><span style="cursor:pointer" class="heading-button">{{transaction.clients}}</span></v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon>
            <v-icon>search</v-icon>
        </v-btn> -->
        <div class="active-indicator" :class="{'active': isTransactionActive}"></div>
        <ToolbarSearch @search="searchWithinTransaction" />
        <v-progress-circular :size="20" :width="2" v-if="isLoading" indeterminate class="white--text"></v-progress-circular>
        <v-menu v-if="!isLoading" bottom left :nudge-width="200" max-height="400">
            <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" dark>
                <v-icon>more_vert</v-icon>
            </v-btn>
            </template>
            <v-list>
                <!-- <v-list-item @click="test">
                    <v-list-item-title>Test</v-list-item-title>
                </v-list-item>             -->
                <v-list-item>
                    <a class="transparent" :href="`/${tenantKey}/transaction/${transaction.masterKey}`" target="_blank">
                        <v-list-item-title>Open the Master Template</v-list-item-title>
                    </a>
                </v-list-item>
                <v-list-item @click="$router.push(`/${tenantKey}/document-checklist/${transactionKey}`)">
                    <v-list-item-title>Go to Checklist</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteAll">
                    <v-list-item-title>Delete All Fields</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteTransaction">
                    <v-list-item-title>Delete Transaction</v-list-item-title>
                </v-list-item>
                <v-list-item @click="importTab(selectedTab)">
                    <v-list-item-title>Refresh Current Tab</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showTransactionHistory()">
                    <v-list-item-title>Activity History</v-list-item-title>
                </v-list-item>
                <v-list-item @click="testFunction">
                    <v-list-item-title>Test Function</v-list-item-title>
                </v-list-item>
                <v-subheader>Advanced</v-subheader>
                <v-list-item v-if="!isMaster" @click="makeTemplate">
                    <v-list-item-title>Make this a Template</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isMaster" @click="removeTemplate">
                    <v-list-item-title>Remove as template</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="columnSplits != '50/50'" @click="columnSplits='50/50'">
                    <v-list-item-title>Bigger Comments Column</v-list-item-title>
                </v-list-item>
                <v-list-item @click="debugMode = !debugMode">
                    <v-list-item-title>Debug Mode</v-list-item-title>
                    <v-checkbox :value="debugMode" class="ml-3" />
                </v-list-item>
                <v-list-item v-if="isAdministrator" @click="viewMilestone">
                    <v-list-item-title>View Milstone in Console</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-toolbar>

    <!-- Tabs -->

    <div class="tab-bar">

        <div class="tab-container">

            <!-- spacer -->

            <div>
                <div class="tab no-select" style="width:100%">&nbsp;</div>
            </div>

            <!-- main tabs -->

            <div v-for="tab in tabs" :key="tab.key" @click="selectTab(tab)">
                <div class="tab clickable" :class="{selected: tab == selectedTab}" :key="tab.key" >

                <div style="display:flex;" class="clickable">

                    <v-icon style="margin-top:-5px;margin-right:5px;" class="tab-icon" :class="{'complete': tab.complete}">star</v-icon>


                    <div class="no-select no-wrap">{{tab.title}}</div>

                    <div style="margin-right:-15px;margin-top:-2px;" @click.prevent.stop>
                        <v-menu left offset-y>
                        <template v-slot:activator="{ on }">
                            <v-icon class="menu-icon" v-on="on">more_vert</v-icon>
                        </template>
                        <v-list>
                            <v-list-item @click="editTab(tab)">
                                <v-list-item-title>Edit Tab</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="clipboard.items.length == 0" @click="moveTabToClipboard(tab)">
                                <v-list-item-title>Cut</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="clipboard.action == 'Tab'" @click="pasteTabFromClipboard(tab)">
                                <v-list-item-title>Paste</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="!tab.complete" @click="completeElement(tab)">
                                <v-list-item-title>Complete</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="importTab(tab)">
                                <v-list-item-title>Refresh Tab</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="reseedOrder">
                                <v-list-item-title>Reseed Sort Order</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="isAdministrator" @click="tabMaintenance(tab)">
                                <v-list-item-title>Element Maintenance</v-list-item-title>
                            </v-list-item>

                        </v-list>
                        </v-menu>
                    </div>

                </div>

                </div>
            </div>

            <!-- spacer -->

            <div style="flex-grow:1">
                <div class="tab no-select" style="width:100%">&nbsp;</div>
            </div>

            <!-- settings tab -->

            <div>
                <v-menu offset-y v-if="!isLoading">
                <template v-slot:activator="{ on }">
                <div v-on="on" class="tab no-select">
                    <v-icon color="grey lighten-1" style="margin-top:-3px">settings</v-icon>
                </div>
                </template>
                <v-list>
                    <v-list-item @click="addTab">
                        <v-list-item-title>Add Tab</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="refreshTabs">
                        <v-list-item-title>Refresh Tabs</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="setSpecialTab('settings')">
                    <v-list-item-title>Transaction Settings</v-list-item-title>
                    </v-list-item>
                </v-list>
                </v-menu>
            </div>

        </div>
    </div>
</template>

<div slot="col1" ref="col1" >
    <div class="flex-grid">

        <div :ref="element.name" v-for="element in tabElements" class="element clickable" :style="getElementStyle(element)" :key="element.key" :class="{selected: isElementSelected(element), important: element.important, compact: element.compact}"
            @dblclick="elementDoubleClicked(element)" @click.exact="elementClicked(element)"
            @click.meta.capture.stop.prevent="selectMulti(element)" @click.ctrl.capture.stop.prevent="selectMulti(element)">

            <table style="table-layout:fixed;width:100%;max-width:100%">
                <tr>
                    <td style="width:99%;padding:0px;border-radius:6px" :style="{'opacity':(element.na ? 0.3 : 'inherit'), 'background-color': getElementBackground(element)}">
                        <elementItem :element="element" @select="selectSingle" @change="storeElementValue" @button="buttonElementClicked" @action="actionElement"  @save-lookup="saveLookup" />
                    </td>
                    <td v-if="element.value && element.value.length > 10 && element.value.startsWith('http') && element.type != 'File'" width="50px">
                        <a :href="element.value" class="transparent" target="_blank">
                        <v-btn class="elevation-0" small fab color="blue lighten-4"><v-icon color="blue" >public</v-icon></v-btn>
                        </a>
                    </td>
                    <td style="width:15px;padding:0px" :style="menuContainerStyle(element)" @click.stop.prevent="">

                        <v-menu left offset-y style="margin-left:-5px;margin-right:-8px;">
                            <template v-slot:activator="{ on }">
                                <v-icon class="menu-icon" v-on="on">more_vert</v-icon>
                            </template>
                            <v-list>
                                <!-- < v-if="!selectedElements.length"> -->
                                <template v-if="!isElementSelected(element)">
                                    <v-list-item v-if="element.type=='Text'" @click="addToComments(element)">
                                        <v-list-item-title>Add to Comments</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="element.type=='Text'" @click="sendElementToNewWindow(element)">
                                        <v-list-item-title>Send to New Window</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editElement(element)">
                                        <v-list-item-title>Edit</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="makeTaskFromElement(element)">
                                        <v-list-item-title>Make Task</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="!element.important" @click="makeImportant(element)">
                                        <v-list-item-title>Important</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-else @click="removeImportant(element)">
                                        <v-list-item-title>Not Important</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="showElementHistory(element)">
                                        <v-list-item-title>History</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="toggleNotApplicable(element)">
                                        <v-list-item-title>
                                            <template v-if="!element.na">Not </template>Applicable
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addAfterElement(element)">
                                        <v-list-item-title>New Element</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="selectMulti(element)">
                                        <v-list-item-title>Select</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="clipboard.items.length" @click="pasteFromClipboard(element)">
                                        <v-list-item-title>Paste</v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template v-else>
                                    <v-list-item @click="cloneSelectedElements">
                                        <v-list-item-title>Clone</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="moveToClipboard('Cut')">
                                        <v-list-item-title>Cut</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="moveToClipboard('Copy')">
                                        <v-list-item-title>Copy</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="deleteElements(selectedElements)">
                                        <v-list-item-title>Delete</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="addFilter(selectedElements)">
                                        <v-list-item-title>Add Filter</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="isAdministrator" @click="elementMaintenance(selectedElements)">
                                        <v-list-item-title>Element Maintenance</v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-menu>

                    </td>
                </tr>
            </table>

            <ElementScheduler v-if="element.scheduleVisible" :element="element" @schedule="scheduleClicked" />

        </div>
    </div>
</div>

<!-- ************** Right Column ************** -->

<div slot="col2" style="background-color:#eee;border-radius:8px;padding:10px;">
    <TimeTracker class="mt-0 mb-1 mr-1" :related-id="transactionKey" :title="transaction.clients" :payload="timeTrackerPayload" />

    <SimultaneousTransactions :transactionKey="transactionKey" />

    <div class="clipboard" v-if="clipboard.items.length">
        <div style="float:left;margin-right:10px"><v-icon large color="grey">assignment</v-icon></div>
        <button @click="clearClipboard" style="padding:4px 8px 4px 8px;float:right;border: solid 1px #888">Clear</button>
        Clipboard ({{this.clipboard.action}})<br/>
        {{this.clipboard.items.map(o=>o.title).join(', ')}}
    </div>

    <!-- Important Items -->

    <div style="width:100%;margin-bottom:10px;background-color:#ddd" class="text-button hoverable clickable" @click="importantVisible =! importantVisible">
        <v-icon v-if="importantVisible" style="float:right;margin-top:-2px" color="grey">keyboard_arrow_up</v-icon>
        <v-icon v-else style="float:right;margin-top:-2px" color="grey">keyboard_arrow_down</v-icon>
        Important Stuff

    </div>
    <v-expand-transition>
    <div v-if="importantVisible" style="width:100%">

        <v-menu v-for="element in importantElements" :key="element.key" offset-y left>
            <template v-slot:activator="{ on }">
                <div v-on="on"  class="clickable hoverable" style="display:flex;color:#555;padding:7px;border-top:dotted 1px #ccc;width:100%" :key="element.key"
                >
                    <div v-if="element.type != 'Widget'" style="font-weight:500;width:120px;margin-right:10px;">
                        {{element.title}}
                    </div>
                    <div  style="flex-grow:1;font-weight:400;margin-right:3px;overflow:auto;">
                        <div v-if="element.type != 'Rating'" class="text-selectable" v-html="formatElement(element)" style="overflow-x:auto">
                        </div>

                        <OutstandingsDiagram v-if="element.widget == 'Outstandings Diagram'"/>

                        <div @click.stop="ratingClicked(element)">
                            <v-rating  v-if="element.type=='Rating'" color="yellow darken-2" background-color="grey lighten-2" v-model="element.value" style="margin-top: -10px;margin-left:-10px;margin-bottom:-10px" />
                        </div>
                    </div>

                    <div style="flex-basis:0">
                        <v-icon @click.stop="removeImportant(element)" color="grey lighten-1" style="font-size:12px">clear</v-icon>
                    </div>
                </div>
            </template>
            <v-list>
                <v-list-item @click="jumpToElement(element)">
                    <v-list-item-title >Jump to Tab</v-list-item-title>
                </v-list-item>
                <v-list-item @click="copyToClipboard(element)">
                    <v-list-item-title >Copy to Clipboard</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <div style="height:10px"></div>
    </div>
    </v-expand-transition>


    <!-- Contacts -->

    <div v-if="!contactsVisible" style="width:100%;margin-bottom:10px;background-color:#ddd" class="text-button hoverable clickable" @click="contactsVisible = true">
        <v-icon v-if="contactsVisible" style="float:right;margin-top:-2px" color="grey">keyboard_arrow_up</v-icon>
        <v-icon v-else style="float:right;margin-top:-2px" color="grey">keyboard_arrow_down</v-icon>
        Show Contacts
    </div>
    <v-expand-transition>
    <div v-if="contactsVisible">

        <div style="display:flex;width:100%;margin-bottom:10px">
            <div class="text-button hoverable clickable" style="flex-grow:1">
                <v-menu style="width:100%" max-height="300" offset-y>
                <template v-slot:activator="{ on }">
                <div v-on="on" style="width:100%">
                    Add Contact
                </div>
                </template>
                <v-list>
                    <v-list-item
                    v-for="role in roles" :key="role" @click="addContact(role)" >
                        <v-list-item-title>{{ role }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="addContact('Other')" >
                        <v-list-item-title>Other</v-list-item-title>
                    </v-list-item>
                </v-list>
                </v-menu>
            </div>
            <div class="text-button hoverable clickable" @click="contactsVisible = false" style="flex-basis:35px;flex-grow:0;margin-left:10px;">
                <v-icon style="margin-top:-2px;margin-left:-3px" color="grey">keyboard_arrow_up</v-icon>
            </div>
        </div>

        <TransactionContacts :contactElements="contactElementsUnique" @click="viewContact" />
        <div v-if="clients.length == 2" class="pb-3 pl-2 ">
            <a href="" @click.stop.prevent="emailBothClients">
                Email Both Clients
            </a>&nbsp;
            <a href="" @click.stop.prevent="clipboardBothClients">
                Both to Clipboard
            </a>
        </div>
    </div>
    </v-expand-transition>


    <!-- Files -->

    <div style="width:100%;margin-bottom:10px;background-color:#ddd" class="text-button hoverable clickable" @click="showFileDialog">
        <template v-if="uploadingCount">
            <v-progress-circular style="float:right" :size="20" :width="2" indeterminate class="grey--text"></v-progress-circular>
            Uploading {{uploadingCount}} Files
        </template>
        <template v-else>
            {{this.fileElements && this.fileElements.length ? this.fileElements.length : 'No'}} Files
        </template>
        <v-icon style="float:right;margin-top:-2px" color="grey">mdi-dots-horizontal</v-icon>

    </div>


    <TransactionTasks />
    <TransactionComments />
    <br/>

    <!-- Email Logs -->

    <div style="width:100%;margin-bottom:10px;background-color:#ddd" class="text-button hoverable clickable" @click="mailLogClick">
        <v-icon v-if="emailsVisible" style="float:right;margin-top:-2px" color="grey">keyboard_arrow_up</v-icon>
        <v-icon v-else style="float:right;margin-top:-2px" color="grey">keyboard_arrow_down</v-icon>
        Emails
    </div>
    <v-expand-transition>
        <div class="light-text" v-if="emailsVisible">
            <TransactionMail :items="mailLog" :showTo="true" />
        </div>
    </v-expand-transition>
</div>

<template slot="dialogs">
    <ElementDialog :settings="elementDialog.settings" :model="elementDialog.model"
        @save="saveElement" @delete="deleteElement"
    />
    <LookupDialog :settings="lookupDialog.settings" :element="lookupDialog.element"
        @save="saveLookupFromDialog"
    />
    <FilterEditor :settings="filterEditorDialog.settings" :elements="filterEditorDialog.elements" :model="filterEditorDialog.model"
        @save="saveFilter" @delete="deleteFilter"
    />

    <ContactSelector :visible="contactSelector.visible" :title="contactSelector.title" :data="contactSelector.data" @select="linkContactFromElement" @cancel="contactSelector.visible = false"></ContactSelector>

    <TransactionContact :settings="transactionContactDialog.settings" title="" :transactionKey="transactionKey" :element="transactionContactDialog.element" @close="transactionContactDialog.settings.visible = false" @unlink="unlinkContact" @edit-element="editElement" @refresh="refreshContact"></TransactionContact>
    <EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" :returnObject="emailDialog.returnObject" @sent="sentEmailMessage"/>
    <SmsDialog :settings="smsDialog.settings" :recipients="smsDialog.recipients" :message="smsDialog.message" :returnObject="smsDialog.returnObject" @sent="sentSMSMessage"/>
    <FileDialog :files="fileElements" :settings="fileDialog.settings" />
    <TaskDialog :task="taskDialog.model" :settings="taskDialog.settings" @save="saveTask" />
    <GenericListDialog :items="genericListDialog.items" :settings="genericListDialog.settings" :clickHandler="genericListDialog.clickHandler"/>
</template>

</LayoutContainer>

</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'

import axios from 'axios'

import { format, addDays, parse} from 'date-fns'

import TimeTracker from '../ui-elements/TimeTracker'
import FileDialog from '../ui-elements/FileDialog'
import TransactionComments from '../ui-elements/TransactionComments.vue'
import TransactionTasks from '../ui-elements/TransactionTasks.vue'
import ElementItem from '../ui-elements/ElementItem.vue'
// import email from '../ui-elements/email'
import EmailDialog from '../ui-elements/EmailDialog'
import SmsDialog from '../ui-elements/SmsDialog'
import ElementDialog from '../ui-elements/ElementDialog.vue'
import ElementScheduler from '../ui-elements/ElementScheduler.vue'
import FilterEditor from '../ui-elements/FilterEditor.vue'
import LookupDialog from '../ui-elements/LookupDialog.vue'
import FilterHelpers from '../helpers/FilterHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import { dateFormats } from '../helpers/DateHelpers'
import NiceData from '../data/NiceData.js'
import draggable from 'vuedraggable'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import UploadFirebase from '../ui-elements/UploadFirebase'
import Utilities from '../helpers/Utilities'
import NumberHelpers from '../helpers/NumberHelpers.js'
import OrderHelpers from '../helpers/OrderHelpers.js'
import ListHelpers from '../helpers/ListHelpers.js'
import ElementHelpers from '../helpers/ElementHelpers.js'
import TransactionContact from '../ui-elements/TransactionContact'
import TransactionMail from '../ui-elements/TransactionMail'
import ContactSelector from '../ui-elements/ContactSelector'
import TransactionContacts from '../ui-elements/TransactionContacts'
import WorkflowFiles from '../ui-elements/TransactionFiles'
import ContactHelpers from '../helpers/ContactHelpers'
import MergeHelpers from '../helpers/MergeHelpers'
import LoanHelpers from '../helpers/LoanHelpers'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import StringHelpers from '../helpers/StringHelpers'
import uploadElementVue from '../ui-elements/UploadElement.vue'
import OutstandingsDiagram from '../ui-elements/OutstandingsDiagram.vue'
import FireData from '../data/FireData'
import ContactData from '../data/ContactData'
import TransactionHelpers from '../helpers/TransactionHelpers'
import MilestoneHelpers from '../helpers/MilestoneHelpers'
import LogHelpers from '../helpers/LogHelpers'
import TaskDialog from '../ui-elements/TaskDialog'
import GenericListDialog from '../ui-elements/GenericListDialog'
import ToolbarSearch from '../ui-elements/ToolbarSearch'
import SimultaneousTransactions from '../ui-elements/SimultaneousTransactions'
import PageHelpers from '../helpers/PageHelpers'
import AppHelpers from '../helpers/AppHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import LoanSecurityHelpers from '../helpers/LoanSecurityHelpers'
import clipboard from 'clipboard-js'
import Firestore from '../data/Firestore'



    export default {
        name: 'Transaction',
        props: {
            tenantKey: String,
        },
        provide() {
            return {
                loadMailFunction: this.loadMail,
            }
        },
        data() {
            return {
                mailLog: [],
                mailLogLoaded: false,
                columnSplits: '65/35',
                localTasks: [],
                lastHelpChange: null,
                generalUpload: {
                    complete: true,
                    message: ''
                },
                selectedElements: [],
                contactsVisible: false,
                importantVisible: false,
                emailsVisible: false,
                filesVisible: false,
                clipboard: {
                    items: [],
                    action: null,
                },
                elementDialog: {
                    settings: {
                        visible: false,
                    },
                    model: {
                        //Model is injected at addAfterElement
                    }
                },
                lookupDialog: {
                    settings: {
                        title: null,
                        visible: false,
                    },
                    element:{},
                },
                filterEditorDialog: {
                    settings: {
                        visible: false,
                        title: 'Add a Filter'
                    },
                    model: {
                        name: 'test',
                    },
                    elements: []
                },
                transactionContactDialog: {
                    settings: {visible:false},
                    element: null
                },
                smsDialog: {
                    settings: {
                        visible:false
                    },
                    message: null,
                    recipients: null,
                    returnObject: {},
                },

                emailDialog: {

                    email: {
                        to: null,
                        cc: null,
                        bcc: null,
                        subject: null,
                        body: '',
                        attachments: [],
                    },
                    settings: {
                        visible: false,
                        sent: false
                    },
                    returnObject: null,
                },
                contactSelector: {
                    visible:false,
                    data: {
                        role: null
                    }
                },
                fileDialog: {
                    settings: {
                        visible: false,
                        closeOnly: true,
                        title: 'All Files',
                    },
                },

                genericListDialog: {
                    settings: {
                        visible: false,
                        title: 'Element History',
                    },
                    items: [],
                    clickHandler: function(){}
                },
                snackbarVisible: false,
                snackbarText: '',
                taskDialog: {
                    settings: {
                        visible: false,
                        title: 'Task Details',
                    },
                    model: {
                        key: null,
                        title: null,
                        due: null,
                        assigned: {},
                    }
                },
            }
        },
        components: {
            LayoutContainer,
            'draggable': draggable,
            TransactionComments,
            TransactionTasks,
            ElementItem,
            FilterEditor,
            ElementDialog,
            // 'email': email,
            EmailDialog,
            SmsDialog,
            ContactSelector,
            TransactionContact,
            TransactionMail,
            TransactionContacts,
            WorkflowFiles,
            UploadFirebase,
            LookupDialog,
            OutstandingsDiagram,
            FileDialog,
            ElementScheduler,
            TaskDialog,
            GenericListDialog,
            SimultaneousTransactions,
            ToolbarSearch,
            TimeTracker,
        },
        computed:{
            isTransactionActive() {
                const isSubmitted = ElementHelpers.getValueFromName('submitted')
                const isSettled = ElementHelpers.getValueFromName('settlement_confirmed')
                const isDeclined = ElementHelpers.getValueFromName('withdrawn_declined')
                return Boolean(isSubmitted && !(isSettled || isDeclined))
            },
            isAdministrator() {
                return DataHelpers.isAdministrator()
            },

            timeTrackerPayload() {
                return {
                    insight: DataHelpers.isInsightUser(),
                    officeKey: DataHelpers.getTenantKey(),
                }
            },

            searchText() {
                return PageHelpers.getPageData('search')
            },

            uploadingCount() {
                return this.$store.getters.uploadingCount
            },

            alertVisible: {
                get: function() {
                    return this.$store.getters.alert.message
                },
                set: function(newValue) {
                    if(!newValue)
                        this.$store.dispatch('clearAlert')
                }
            },
            alertMessage() {
                return this.$store.getters.alert.message
            },


            tabs() {
                //return this.tabsData.sort(OrderHelpers.sortAscending)
                return this.$store.getters.elements.filter(o => o.type && o.type == 'Tab').sort(OrderHelpers.sortAscending)
            },

            isLoading() {
                return this.elements.length == 0
            },

            isMaster() {
                return this.transaction.isTemplate
            },
            tabElements() {
                if(this.searchText) {
                    if(this.searchText.toLowerCase() == 'links') {
                        return this.elements.filter(o => o.type != 'File' && o.value && typeof o.value == 'string' && o.value.indexOf('http') == 0)
                    }
                    return this.elements.filter(o => {
                        return (o.title || '').toLowerCase().indexOf(this.searchText) > -1
                    })
                }

                if(!this.selectedTab)
                    return []

                return this.elements.filter(o => o.tabKey && o.tabKey == this.tabKey).sort(OrderHelpers.sortAscending)
            },
            elements() {
                return ElementHelpers.getElements()
            },

            importantElements() {
                return this.elements.filter(o => o.important).sort(OrderHelpers.sortByTitle)
            },

            transactionKey() {
                return this.$route.params.transaction || ""
            },
            tabKey() {
                return this.$route.query.tab || (
                    this.selectedTab ? this.selectedTab.key : ''
                )
            },
            transaction() {
                let transaction = this.$store.getters.transaction

                //todo: temporary to ensure master in old files
                if(!transaction.masterKey) {
                    console.error('Still need fallback masterkey (transaction.vue)')
                    transaction.masterKey = '-LG-kkb1y_ZwFJ9GYSZj'
                }

                return transaction
            },

            elementRef() {
                return DataHelpers.getTransactionRef().child('elements')
            },
            selectedTab() {
                return this.$store.getters.selectedTab
            },

            selectedSection() {
                return this.$store.getters.selectedSection
            },

            masterElements() {
                return this.$store.getters.masters[this.transaction.masterKey]
            },
            // loadedTabs() {
            //     return this.$store.getters.loadedTabs
            // },
            contactElements() {
                return this.elements.filter(o => o.contact)
            },

            contactElementsUnique() {
                return ElementHelpers.contactElementsUnique(this.elements)
            },

            clients() {
                return this.contactElements.filter(o => o.role == 'Client').map(o => {
                    return {...o.contact, key: o.contactKey, role: 'Client'}
                })
            },

            fileElements() {
                return this.elements.filter(o => o.type == 'File' && (o.value || o.loading)).sort(OrderHelpers.sortByTimestampDescending)
            },
            roles() {
                const roles = this.$store.getters.groups.filter(o => o.role == true).map(o => o.name)
                if(this.isMaster)
                    return roles.filter(o => o != 'Broker')
                else
                    return roles
            },
            pageSearchText() {
                return PageHelpers.getPageData('search')
            },
            debugMode: {
              get: function() {
                  return AppHelpers.getApplicationData('debugMode')
              },
              set: function(newValue) {
                AppHelpers.setApplicationData('debugMode', newValue)
              }
            },
            officeName() {
                return DataHelpers.officeName()
            }

        },



        methods: {

            mailLogClick() {
                this.emailsVisible =! this.emailsVisible
                if(this.emailsVisible && !this.mailLogLoaded)
                    this.loadMail()
            },

            async loadMail() {

                const refs = this.getClientEmailRefs()

                const result = await Firestore.fetchMulti(refs)

                this.mailLog = result.sort(OrderHelpers.sortByCreatedAtDescending)

                this.mailLogLoaded = true

                return this.mailLog
            },

            getClientEmailRefs() {
                const mailRef = Firestore.getCollectionDocumentRefFromPath('teams/global/collections/mail/data')

                const refs = []
                this.clients.forEach(client => {
                    if(client.email) {
                        const emailObj = {email: client.email}
                        refs.push( mailRef.where('email.to', 'array-contains', emailObj).limit(200) )
                    }
                })
                return refs
            },

            viewMilestone() {
                const path = 'tenants/' + this.tenantKey + '/milestones/' + this.transactionKey
                FirebaseHelpers.viewInConsole(path)
            },

            addToComments(element) {
                const section = this.getElementSection(element, this.elements)
                let comment = {
                    text: element.value + ' (from ' + element.title + ')',
                    sectionKey: (section ? section.key : null),
                    tabKey: element.tabKey || null,
                    // milestone: true,
                }

                this.$store.dispatch('saveTransactionComment', comment)
            },

            sendElementToNewWindow(element) {
                Utilities.openWindowWithHtml(element.title, element.value)
            },

            getElementBackground(element) {
                if(!this.isMaster)
                    return 'auto'
                const isFiltered = (element &&
                    element.filter &&
                    Object.keys(element.filter).length > 0
                )

                const isTasked = (element &&
                    element.tasks &&
                    Object.keys(element.tasks).length > 0
                )

                if(isFiltered && isTasked)
                    return '#fff2cc'

                if(isTasked)
                    return '#ffccf6'

                if(isFiltered)
                    return '#FBEFF2'

                return 'auto'
            },

            // elementHasFilter(element) {
            //     return (
            //         element &&
            //         element.filter &&
            //         Object.keys(element.filter).length > 0
            //     )

            // },

            //copy the element text value to the os clipboard...
            copyToClipboard(element) {
                let text = element.value
                clipboard.copy({'text': text})

                AlertHelpers.showAlert('Copied to clipboard')
            },

            searchWithinTransaction(searchText) {
                PageHelpers.setPageData('search', searchText)
            },

            ratingClicked(element) {
                //console.log('Important Rating Clicked')
                setTimeout( () => {
                    this.saveElement(element)
                },1000)
            },

            showElementHistory(element) {
                let ref = DataHelpers.getTenantRef().child('log').orderByChild('transactionKey').equalTo(this.transactionKey).limitToLast(500)
                let items
                NiceData.fetchItemsFromFirebase(ref).then(result => {
                    result = result.filter(o => o.elementKey == element.key).reverse().map(item => {
                        if(item.type == 'email') {
                            item = LogHelpers.createListItem(item)

                        } else if(item.type == 'element') {
                            item.meta = {...item.meta,
                                listKey: item.meta.key,
                                listTitle: 'Changed to ' + (item.value || 'Empty'),
                                listDetails: item.stamp.firstName + ' ' + item.stamp.lastName + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                                listIcon: 'tune'
                            }

                        } else
                            debugger
                        return item
                    })

                    this.genericListDialog.items = result
                    this.genericListDialog.settings.closeOnly = true
                    this.genericListDialog.settings.visible = true
                    this.genericListDialog.clickHandler = this.historyClicked
                })
            },

            showTransactionHistory() {
                let ref = DataHelpers.getTenantRef().child('log').orderByChild('transactionKey').equalTo(this.transactionKey).limitToLast(200)
                let items
                NiceData.fetchItemsFromFirebase(ref).then(result => {
                    result = result.reverse().map(item => {
                        if(item.type == 'email') {
                            item = LogHelpers.createListItem(item)
                        } else if(item.type == 'element') {
                            item.meta = {...item.meta,
                                listKey: item.meta.key,
                                listTitle: 'Changed "' + item.elementTitle + '" to ' + (item.value || 'empty'),
                                listDetails: item.stamp.firstName + ' ' + item.stamp.lastName + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                                listIcon: 'tune'

                            }

                        } else if(item.type == 'transaction viewed') {
                            item.meta = {...item.meta,
                                listKey: item.meta.key,
                                listTitle: 'Viewed by ' + ContactHelpers.fullName(item.stamp) || 'Empty',
                                listDetails: item.stamp.firstName + ' ' + item.stamp.lastName + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                                listIcon: 'visibility'
                            }

                        } else
                            debugger
                        return item
                    })

                    this.genericListDialog.items = result
                    this.genericListDialog.settings.closeOnly = true
                    this.genericListDialog.settings.visible = true
                    this.genericListDialog.clickHandler = this.historyClicked
                })
            },

            historyClicked(item) {
                console.log ('history clicked', item)
                if(item.type == 'email') {
                    this.emailDialog.email = item.email
                    this.emailDialog.settings.sent = true
                    this.emailDialog.settings.visible = true
                }
            },

            emailBothClients() {
                console.log ('emailing both clients')
                this.emailDialog.email.to = this.clients
                this.emailDialog.settings.group = 'General'
                this.emailDialog.settings.template = 'Blank'
                this.emailDialog.settings.title = 'Email Client'
                this.emailDialog.settings.visible = true
            },

            clipboardBothClients() {
                let clientDetailsArr = []
                this.clients.forEach(client => {
                    clientDetailsArr.push( ContactHelpers.contactDetailsToText(client) )
                })
                const str = ContactHelpers.combineClientsNames(this.clients) + ':' + clientDetailsArr.join(', ')

                clipboard.copy({'text': str})

                AlertHelpers.showAlert('Copied to clipboard')
            },

            showTaskDialog(element) {

                const dateStr = addDays(new Date(), 1).formatBackwards()

                this.taskDialog.model.due = dateStr
                this.taskDialog.model.title = element.scheduleText || element.title
                this.taskDialog.model.assigned = DataHelpers.getUser()
                this.taskDialog.settings.visible = true
                this.taskDialog.settings.triggerElement = element
            },

            showFileDialog() {
                this.$store.commit('uploadingCount', 0)
                this.fileDialog.element = this.element
                this.fileDialog.settings.visible = true
            },

            async deleteTransaction() {
                if(await this.$root.$confirm('Delete', 'Are you sure you want to delete this transaction?', { color: 'red' }) == true) {
                    TransactionHelpers.deleteTransaction(this.transactionKey)
                    this.$router.push({ path: '/home'})
                }
            },

            refreshContact(element) {
                ContactData.fetchContactSingle(element.contactKey).then(contact => {
                    const simpleContact = ContactHelpers.simplifyContact(contact)
                    element.contact = simpleContact
                    element.value = ContactHelpers.fullName(simpleContact)
                    this.saveElement(element)
                })

                if(element.role == 'Client' || element.role == 'Guarantor')
                    ContactData.contactTransactionAdd(element.contactKey, this.transactionKey)

                if(element.role == 'Client')
                    this.refreshTransactionClients()

            },

            formatElement(element) {
                return MergeHelpers.formatElement(element, this.elements)
            },

            async testFunction() {
                const structure = await LoanSecurityHelpers.fetchLoanStructure(this.transactionKey)
                const summary = LoanSecurityHelpers.loanSummary(structure)
                console.log(summary)
            },

            elementsToRecipients(role) {
                return this.contactElements.filter(o => o.role == role).map(o => {
                    return {
                        email: o.contact.email || null,
                        firstName: o.contact.firstName,
                        preferredName: o.contact.preferredName || null,
                        lastName: o.contact.lastName || null,
                        fullName: ContactHelpers.fullName(o.contact),
                        mobile: o.contact.mobile,
                        role: o.role,
                        image: o.contact.image,
                        key: o.contactKey
                    }
                })
            },

            completeElement(element) {
                element.complete = true
                this.saveElement(element)
            },

            merge(str) {
                return MergeHelpers.merge(str, this.elements)
            },

            fileMenu(action, element) {
                if(action == 'delete')
                    this.deleteElement(element)
                else if(action == 'email')
                    this.emailFiles([element])
            },

            emailFiles(fileElements) {
                this.emailDialog.to = this.clients
                this.emailDialog.role = 'Client'
                this.emailDialog.group = 'General'
                this.emailDialog.name = 'Blank'
                this.emailDialog.title = 'Email Client'
                this.emailDialog.attachments = fileElements
                this.emailDialog.data = {
                    elements: this.elements
                }
                this.emailDialog.visible = true

            },

            reseedOrder() {
                let order = 0
                this.tabElements.forEach(element => {
                    order += 1000
                    let elementChanges = {
                        key: element.key,
                        order,
                    }
                    this.saveElement(elementChanges)
                })
                AlertHelpers.showAlert('Elements reseeded. Refresh to take effect')
            },

            uploadStart(upload) {

                upload.tabKey = 'settings'
                upload.transactionKey = this.transactionKey
                upload.type = 'File'
                upload.title = upload.name
                this.saveElement(upload)
            },

            uploadFinish(upload) {
                upload.value = upload.url
                this.saveElement(upload)
            },

            uploadFinishAll(payload) {
                AlertHelpers.showAlert('Finished uploading ' + payload.files)
            },

            setSpecialTab(name) {
                this.selectTab({
                    key: name,
                    title: StringHelpers.capitalizeFirstLetter(name),
                    name: name,
                    type: 'Tab'
                })
            },

            displayLookup(element) {
                this.lookupDialog.element = {...element}
                this.lookupDialog.settings.title = element.title
                this.lookupDialog.settings.path = this.merge(element.lookup).replace(/\//g, ' > ')
                this.lookupDialog.settings.visible = true
            },

            saveLookupFromDialog(element) {

                this.saveElement(element)
                let path = this.merge(element.lookup)

                this.saveLookup(path, element.value, element.global)
                AlertHelpers.showAlert('Saved for later')
            },

            saveLookup(path, value, global) {

                const ref = (global ? DataHelpers.getRootRef().child('app') : DataHelpers.getTenantRef() ).child('lookup')

                let lookupPath = MergeHelpers.merge(path, this.elements)

                var re = new RegExp(/\[.*?\]/);
                var found = re.test(lookupPath);

                if(found) {
                    Utilities.log('Didnt save lookup. Cant resolve path')
                    return
                }
                Utilities.log('saveLookup', lookupPath, value)
                AlertHelpers.showAlert("Remembering for next time")

                this.lookup(ref, lookupPath).then((foundObj) => {
                    //let ref = DataHelpers.getTenantRef().child('lookup')
                    let key = foundObj.key || DataHelpers.getKey()
                    ref.child(key).update({path:lookupPath, 'value':value})
                })

            },

            lookup(ref, path) {

                return new Promise((resolve, reject) => {
                    ref.orderByChild('path').equalTo(path).once('value', (snap) => {
                        let obj = FirebaseHelpers.snapshotToObject(snap)

                        if(obj)
                            resolve(obj)
                        else
                            resolve('{value:null}')
                    })
                })
            },

            actionElement(action, element){

                if(action == 'email')
                    this.sendElementEmail(element)
                else if(action == 'sms')
                    this.sendElementSMS(element)
                else if(action == 'jump-from')
                    this.jumpFromElement(element)
                else if(action == 'jump-to')
                    this.jumpToElement(element)
                else if(action == 'contact')
                    this.selectContactFromElement(element)
                else if(action == 'contact-view')
                    this.viewContact(element)
                else if(action == 'contact-remove')
                        this.removeContactFromTransaction(element)
                else if(action == 'make-task')
                        this.makeTaskFromElement(element)
                else if(action == 'import-outstandings') {
                    let outstandings = element.items
                    let triggerElement = element.element
                    this.importOutstandings(outstandings, triggerElement)
                } else if(action == 'display-lookup')
                        this.displayLookup(element)
                else if(action == 'email-files')
                        this.emailFiles(element)
                else if(action == 'choose-user')
                        this.chooseUser(element)
                else
                    console.log('transaction > actionElement (unknown action)', action, element)
            },

            jumpFromElement(element) {
                let targetElement = this.elements.find(o => o.name == element.target)
                if(!targetElement) {
                    AlertHelpers.showAlert('Target element not found')
                    return
                }
                this.jumpToElement(targetElement)
            },

            jumpToElement(element) {
                let targetTab = this.tabs.find(o => o.key == element.tabKey)
                this.selectTab(targetTab, element.name)
            },

            importOutstandings(outstandings, triggerElement) {
                let elements = outstandings.map(item => {
                    let element = this.createElement()
                    element.type = 'Outstanding'
                    element.title = 'Outstanding'
                    element.text = item
                    element.status = 'Waiting for Client'
                    return element
                })
                console.log('importOutstandings', elements, triggerElement)
                this.injectElements(elements, this.tabElements, triggerElement, true)

            },

            viewContact(element) {

               //todo: remove this....was to fix bug with missing contactKey
                // removed 2/11/21 this.fixContactKey(element)

                let contact = Object.assign({key: element.contactKey}, element.contact)
                this.transactionContactDialog.model = contact
                this.transactionContactDialog.element = element

                this.transactionContactDialog.settings.visible = true
            },

            //todo: remove this....
            //removed 2/11/21
            // fixContactKey(element) {
            //     if(!element.contactKey)
            //         element.contactKey = element.key
            // },

            addContact(role) {
                Utilities.log('addContact')
                this.contactSelector.data.role = role || ''
                this.contactSelector.data.element = {
                    tabKey: 'settings',
                    transactionKey: this.transactionKey,
                    type: 'Contact',
                }
                this.contactSelector.visible = true
            },

            selectContactFromElement(element) {
                Utilities.log('selectContactFromElement')
                this.contactSelector.data.role = element.role || ''
                this.contactSelector.data.element = element
                this.contactSelector.title = 'Include a ' + element.role || 'Contact'

                this.contactSelector.visible = true
            },

            removeContactFromTransaction(contactElement) {
                this.deleteElement(contactElement)

                contactElement.value = null
                this.importAffectedElements(contactElement)
            },

            chooseUser(payload) {
                let contactElement = ContactHelpers.replaceContact(this.transactionKey, payload.user, payload.role, this.elements)
                this.importAffectedElements(contactElement)
            },

            linkContactFromElement(contact, data) {
                this.linkContact(contact, data.role)
                this.contactSelector.visible = false
            },

            linkContact(contact, role) {

                //new
                let newElement = ContactHelpers.linkContact(this.transaction.key, contact, role)
                this.importAffectedElements(newElement)

                //Add to contacts menu of transactions...
                debugger
                if(newElement.role == 'Client') {
                    let ref = DataHelpers.getTenantRef().child('contactTransactions').child(newElement.contactKey).child(this.transactionKey)
                    ref.set({
                        clients: this.transaction.clients,
                        description: this.transaction.description,
                        created: DateHelpers.todayString(),
                    })
                }
            },

            async unlinkContact(contact) {
                let contactKey = contact.meta.key
                Utilities.log('unlinkContact', contact)
                let element = this.elements.find(o => (o.contactKey == contactKey) )

                if(element.role == 'Client') {
                    if(this.clients.length < 2) {
                        await this.$root.$confirm('Cannot Delete', 'This is the only remaining client', { color: 'red' })
                        return
                    }
                    Utilities.log('Also removing link in client menu...')
                    let transactionKey = this.transactionKey
                    const contactTransactionRef = DataHelpers.getTenantRef().child('contactTransactions').child(contactKey).child(transactionKey)
                    contactTransactionRef.remove()
                }

                this.deleteElement(element)

            },

            sendTemplateEmail(role, group, template) {
                this.emailDialog.email.to = this.elementsToRecipients(role).filter(o => o.email)
                this.emailDialog.settings.group = group
                this.emailDialog.settings.template = template
                this.emailDialog.settings.customFields = [
                    {'transaction_link': 'http://www.microsoft.com'}
                ]
                this.emailDialog.settings.visible = true
            },

            sendElementEmail(element) {
                Utilities.log('sendElementEmail')
                let to = this.elementsToRecipients(element.role).filter(o => o.email)

                if(!to.length && element.role && !this.isMaster) {
                    const msg = `Nobody with an email was found for role: '${element.role}'`
                    AlertHelpers.showAlert(msg)
                }

                if(element.toField) {
                    const toElement = this.elements.find(o => o.name == element.toField)
                    if(toElement && toElement.value) {
                        const toArray = toElement.value.split('|')
                        const email = toArray[0]
                        const firstName = (toArray.length > 1 ? toArray[1] : '')
                        const toContact = {
                            email,
                            firstName,
                            key: DataHelpers.getKey(),
                        }
                        to = []
                        to.push(toContact)
                    } else {
                        AlertHelpers.showAlert('Value not found for ' + element.toField)
                    }
                }



                this.emailDialog.email.to = to || null
                this.emailDialog.settings.group = element.emailGroup
                this.emailDialog.settings.template = element.emailName
                this.emailDialog.attachments = []
                this.emailDialog.returnObject = element
                this.emailDialog.settings.visible = true
            },

            sendElementSMS(element) {
                console.log('sendElementSMS')
                this.smsDialog.recipients = this.elementsToRecipients(element.role).filter(o => o.mobile)
                this.smsDialog.message = element.message
                this.smsDialog.settings.title = 'Send SMS'
                this.smsDialog.returnObject = element
                this.smsDialog.settings.visible = true
            },

            sentEmail(data) {
                Utilities.log('transaction > sentEmail')
                this.emailDialog.visible = false


                if(!data)
                    return

                let element = data.element
                if(element) {
                    element.complete = true
                    this.saveElement(element)
                }
            },

            sentSMSMessage(element) {
                Utilities.log('transaction > sentSMSMessage')
                AlertHelpers.showAlert('SMS Sent')

                if(!element)
                    return

                element.complete = true
                this.saveElement(element)
            },

            //new version
            sentEmailMessage(element) {
                Utilities.log('transaction > sentEmailMessage')

                if(!element)
                    return

                element.complete = true
                this.saveElement(element)

            },

            addFilter() {
                this.filterEditorDialog.settings.visible = true
            },

            elementMaintenance() {
                let selectedElementsString = this.selectedElements.map(o => o.key).join(',')
                window.open('/maintenance/?action=tme&transaction=' + this.transactionKey + '&item=' + selectedElementsString)
            },
            tabMaintenance(tab) {
                window.open('/maintenance/?action=tme&transaction=' + this.transactionKey + '&item=' + tab.key)
            },

            saveFilter(filter) {
                let filterArray = []
                filterArray.push(filter)
                let filterObject = FilterHelpers.filterArrayToObject(filterArray)

                Utilities.log('saveFilter')
                this.selectedElements.forEach(element => {

                    let newElement = Object.assign({}, element)
                    newElement.filter = newElement.filter || {}

                    newElement.filter = Object.assign(newElement.filter, filterObject)
                    this.$store.dispatch('saveElement', newElement)
                })

                AlertHelpers.showAlert(`Filter added to ${this.selectedElements.length} elements`)
            },

            deleteFilter(filter) {
                Utilities.log('deleteFilter')
            },

            //import and deport related....

            initialImport() {
                if(this.isMaster) {
                    Utilities.log('Initial import skipped. In master template.')
                    return
                }

                //todo: this is not very robust

                if(this.elements.length > 5) {
                    Utilities.log('Initial import skipped. Elements exist.')
                    return
                }

                AlertHelpers.showAlert('Importing workflow')

                setTimeout( () => {
                    let noFilterMasterElements = this.masterElements.filter(o => !o.filter)
                    noFilterMasterElements.forEach(element => {
                        this.import(element)
                    })
                }, 1000)

            },

            importTab(tab) {
                if(this.isMaster) {
                    Utilities.log('Initial import skipped. In master template.')
                    return
                }

                let tabMasterElements = this.masterElements.filter(o => o.tabKey == tab.key)
                tabMasterElements.forEach(element => {
                    if(
                        this.shouldElementBeVisible(element)
                        // && element.type != 'Widget'  //dont override loan diagram etc
                    )
                        this.import(element)
                })

                AlertHelpers.showAlert('Elements refreshed for tab')
            },

            refreshTabs() {
                if(this.isMaster) {
                    Utilities.log('Refresh skipped. In master template.')
                    return
                }

                let tabMasterElements = this.masterElements.filter(o => o.type == 'Tab')
                tabMasterElements.forEach(element => {
                    if(this.shouldElementBeVisible(element))
                        this.import(element)
                })

                AlertHelpers.showAlert('Tabs refreshed')
            },

            storeElementValue(element) {

                this.stampMilestoneElement(element)
                this.$store.dispatch('updateElementValue', element)
                this.importAffectedElements(element)
                this.createAutomaticTasks(element)
                this.saveMilestone(element)
                this.processSpecialTypes(element)
                this.showSchedulersForElement(element)
                this.syncTransactionField(element)
                this.logElementChange(element)


            },

            stampMilestoneElement(element) {
                if(element.milestone)
                    element.stamp = DataHelpers.getStamp()
            },

            syncTransactionField(element){

                if(!element.transactionField)
                    return
                let val = element.value
                if(typeof val == 'undefined')
                    val = ''
                let obj = {}
                obj[element.transactionField] = val

                if(element.transactionField == 'description') {
                    //special case needs advanced logic to do denormalised data...
                    TransactionHelpers.renameTransaction(this.transactionKey, val)
                }
                else {
                    let ref = DataHelpers.getTransactionRef().child('details')
                    ref.update(obj)
                }
            },

            logElementChange(element) {
                if(this.isMaster || element.type == 'Diagram Summary' || !element.title)
                    return

                let logItem = LogHelpers.createLogItem()
                logItem.type = 'element'
                logItem.elementKey = element.key
                logItem.elementTitle = element.title || element.name || 'No name'
                logItem.value = element.value || ''
                this.logTransactionAction(logItem)
            },

            logTransactionView() {
                let logItem = LogHelpers.createLogItem()
                logItem.type = 'transaction viewed'
                this.logTransactionAction(logItem)
            },

            logTransactionAction(logItem) {
                logItem.userKey = DataHelpers.getUserId()
                logItem.tenantKey = DataHelpers.getTenantKey()
                logItem.transactionKey = this.transactionKey
                logItem.transactionClients = this.transaction.clients
                LogHelpers.log(logItem)
            },

            showSchedulersForElement(element) {
                if(!element.value && !element.complete)
                    return
                if(!element || !element.name)
                    return
                let affectedElements = this.elements.filter(o => o.scheduleTrigger == element.name)

                affectedElements.forEach(element => {
                    this.$set(element, 'scheduleVisible', true)
                    setTimeout(() => {
                        this.$set(element, 'scheduleVisible', false)
                    },20000)
                })
            },

            //could bypass this by emitting straight to setElementByName?
            processSpecialTypes(element) {
                // loanDiagram. Get all summary fields and turn them into elements, then process the elements as normal (ie importing dependencies etc)
                // Handles version 2 of diagram which stores summary in element when element is saved
                if(element.widget == 'Loan Diagram') {
                    let summary
                    if(element.version == 2)
                        summary = element.summary
                    else
                        summary = LoanSecurityHelpers.loanSummary(element.diagram)
                    for(let prop in summary) {
                        const item = summary[prop]

                            let newEl = {
                                key: item.id,
                                name: item.name,
                                tenantKey: element.tenantKey,
                                title: item.title || null,
                                transactionKey: element.transactionKey,
                                type: 'Diagram Summary',
                                value: item.value || null,
                                dashboards: item.dashboards || null
                            }

                            this.storeElementValue(newEl)
                    }
                }

            },

            setElementByName(name, value) {
                let element = this.elements.find(o => o.name == name)
                if(!element){
                    console.log('setElementByName > not found ', name)
                    return
                }

                element.value = value
                this.storeElementValue(element)
            },

            //todo: this is temporarily called to bring status up to date in
            // milestones. later will be handled in saveMilestone()
            saveActiveStatusToMilestone() {
                const msRef = DataHelpers.getTenantRef().child('milestones').child(this.transactionKey)
                msRef.update({'active': this.isTransactionActive})
                console.log('*** temporarily saving active status on closing ***')
            },

            saveMilestone(element) {

                if(
                    !(element.milestone || element.dashboards)
                    || this.isMaster
                )
                    return

                //save to milestones summary (for use in dashboards)

                const msRef = DataHelpers.getTenantRef().child('milestones').child(this.transactionKey)
                NiceData.fetchValue(msRef.child('updated')).then(updated => {
                    // if(!updated) {
                        MilestoneHelpers.transferClientsFromTransaction(this.transactionKey)
                        MilestoneHelpers.transferBrokerAndProcessor(this.transactionKey)
                    // }
                    let msObj = {}
                    msObj['updated'] = DateHelpers.todayString()
                    msObj['active'] = this.isTransactionActive
                    msObj[element.name] = element.value
                    msObj[element.name + '_date'] = DateHelpers.todayString()
                    msObj[element.name + '_type'] = element.type   //is type neccessary?
                    msRef.update(msObj)
                    console.log('Saving milestone data', msObj)
                    //AlertHelpers.showAlert('Saving milestone info')
                })

                if(!element.milestone || this.isMaster)
                    return


                //save to section

                let section = this.getElementSection(element, this.tabElements)
                if(!section) {
                    Utilities.log('saveMilestone - Section not found for element', element)
                    return
                }

                section.status = element.title + ': ' + element.value

                if(element.type=="Checkbox")
                    if(element.value)
                        section.status = element.title
                    else
                        section.status = null

                if(element.type=="Options")
                    section.status = element.value || null

                this.saveElement(section)

                //save to comments

                if(!section.status)
                    return

                let comment = {
                    text: section.status,
                    sectionKey: section.key,
                    tabKey: this.selectedTab.key || null,
                    milestone: true,
                }
                this.$store.dispatch('saveTransactionComment', comment)

                setTimeout( () => {
                    this.saveSummary(section, element)
                }, 1000)
            },

            saveSummary(section, element) {
                const sectionName = section.name
                const transactionKey = this.transactionKey
                const transactionClients = this.transaction.clients
                if(!transactionKey || !sectionName) {
                    console.error('saveSummary > No section name or transaction')
                    return
                }

                let ref = DataHelpers.getTransactionSummaryRef().child(section.name).child(this.transactionKey)
                let obj = {
                    'status': section.status,
                    'clients': transactionClients,
                    'stamp': DataHelpers.getStamp(),
                    'active': this.isTransactionActive,
                }
                ref.update(obj)
            },

            importAffectedElements(element) {

                let affectedElements = this.getAffectedElements(element, this.masterElements)

                Utilities.log('Affected elements', affectedElements)

                affectedElements.forEach(targetElement => {
                    if(this.shouldElementBeVisible(targetElement))
                        this.import(targetElement)
                    else
                        this.deport(targetElement)

                })
            },

            import(element) {
                if(this.isMaster) {
                    Utilities.log('Import - Simulation Only in Master File', element.name)
                    return
                }
                let newElement = Object.assign({}, element)

                if(newElement.type == 'Contact')
                    if(newElement.title == 'Client')
                        return
                else {
                    delete newElement['value']

                    //for checklist items not to be overridden...
                    delete newElement['checklist']
                    delete newElement['percent']
                }

                if(newElement.type == 'File')
                    return

                if(newElement.transactionField)
                    newElement.value = this.getTransactionField(newElement.transactionField)

                newElement.stamp = DataHelpers.getStamp()
                newElement.transactionKey = this.transactionKey

                // Lookup
                if(element.type == 'Lookup') {
                    const ref = (element.global ? DataHelpers.getRootRef().child('app') : DataHelpers.getTenantRef() ).child('lookup')

                    let lookupPath = MergeHelpers.merge(element.lookup, this.elements)
                    this.lookup(ref, lookupPath).then(obj => {

                        newElement.value = obj.value || null
                        this.$store.dispatch('saveElement', newElement)
                    })
                }
                // Normal elements...
                else {
                    this.$store.dispatch('saveElement', newElement)
                }
            },

            getTransactionField(field) {
                return this.transaction[field] || null
            },

            deport(element) {
                if(this.isMaster) {
                    Utilities.log('Deport - Simulation Only in Master File', element.name)
                    return
                }
                this.deleteElement(element)
            },

            shouldElementBeVisible(element) {
                console.log('shouldElementBeVisible...')
                for(let triggerElementName in element.filter) {
                    if(element.filter.hasOwnProperty(triggerElementName)) {
                        let localElement = this.elements.find(o => o.name == triggerElementName)
                        let localElementValue = (localElement ? localElement.value: '')
                        Utilities.log('* ' + element.title + ' * : Testing ', triggerElementName + ' from filter, and got a value of ' + localElementValue)

                        let match = false

                        let filterObj = element.filter[triggerElementName].visible

                        let operator = filterObj.operator
                        filterObj.values.forEach(filterValue => {
                            if(this.broadMatch(filterValue, localElementValue))  {
                                match = true
                            }
                        })
                        let wantMatch = (operator == 'e')

                        if(match != wantMatch)
                            return false

                    }
                }
                return true
            },

            broadMatch(filterVal, currentVal) {
                if(!currentVal)
                    currentVal = ''

                if(filterVal == currentVal)
                    return true

                if(filterVal == 'Yes' && currentVal == true)
                    return true

                if(filterVal == 'No' && currentVal == false)
                    return true

                if(filterVal == 'Blank' && currentVal == '')
                    return true

                if(filterVal == 'Non Blank' && currentVal != '')
                    return true

                return false

            },

            getAffectedElements(element, elements) {
                return this.masterElements.filter(o => o.filter && o.filter[element.name])
            },


            buttonElementClicked(element) {
                Utilities.log('button clicked', element)
                let elementList = []
                let startIndex = this.tabElements.findIndex(o => o.key == element.key)
                let offset = 1
                let targetElement = element

                if(element.buttonElements == 'Section') {
                    let sectionElements = this.getElementsInSection(element, this.tabElements)
                    let startingElement = sectionElements[sectionElements.length - 1]
                    this.injectElements(sectionElements, this.tabElements, startingElement, true)
                    return
                }


                if(element.buttonElements == 'Previous') {
                    offset = -1
                    targetElement = this.tabElements[startIndex - 1]
                }

                for(var n=1; n<= element.buttonElementCount; n++) {
                    let newElement = this.tabElements[startIndex + (offset * n)]
                    elementList.push(Object.assign({}, newElement))
                }
                elementList = elementList.sort(OrderHelpers.sortAscending)
                this.injectElements(elementList, this.tabElements, targetElement, true)

            },

            moveToClipboard(action) {
                this.clipboard.action = action
                this.clipboard.items = this.selectedElements.sort(OrderHelpers.sortAscending)
                this.selectedElements = []
            },

            moveTabToClipboard(tab) {
                this.clipboard.action = 'Tab'
                this.clipboard.items = [tab]
            },

            pasteFromClipboard(baseElement) {
                this.injectElements(this.clipboard.items, this.tabElements, baseElement, this.clipboard.action == 'Copy')
                this.clearClipboard()
            },
            pasteTabFromClipboard(baseElement) {
                this.injectElements(this.clipboard.items, this.tabs, baseElement, false)
                this.clearClipboard()
            },

            cloneSelectedElements() {
                let startingElement = this.selectedElements[this.selectedElements.length -1]
                this.injectElements(this.selectedElements, this.tabElements, startingElement, true)
                this.selectedElements = []
            },

            injectElements(fromArray, toArray, afterItem, makeCopy) {
                let firstOrder = parseInt(afterItem.order || 0)
                let lastOrder = OrderHelpers.orderKey()
                let nextElement = Utilities.arrayNextObject(afterItem, toArray)

                if(nextElement) {
                    lastOrder = parseInt(nextElement.order)
                }

                let sourceArray = fromArray.sort(OrderHelpers.sortAscending)

                let orderIncrement = parseInt( (lastOrder - firstOrder) / (sourceArray.length + 1) )

                for(let n=1; n <= sourceArray.length; n++) {

                    let fromItem = sourceArray[n -1]

                    let blankItem = {}
                    if(makeCopy) {
                        blankItem = ListHelpers.prepareSave({})
                        blankItem.name = ElementHelpers.uniqueName(fromItem.name || fromItem.title, sourceArray.map(o => o.name))

                        blankItem.targetName = ElementHelpers.uniqueName(fromItem.targetName, sourceArray.map(o => o.targetName))
                        blankItem.value = null
                    }

                    let newElement = Object.assign({}, fromItem, blankItem)
                    let newOrder = firstOrder + (n * orderIncrement)
                    newElement.order = newOrder

                    newElement.tabKey = this.tabKey
                    if(newElement.type == 'Tab')
                        newElement.tabKey = null

                    this.$store.dispatch('saveElement', newElement)
                }
            },

            clearClipboard() {
                this.clipboard = {items: [], action:null}
            },

            addTab() {

                let tab = {
                    type: 'Tab',
                    order: OrderHelpers.orderKey()
                }
                this.editTab(tab)
            },

            editTab(tab) {
                this.elementDialog.model = Object.assign({}, tab)
                this.elementDialog.settings.visible = true
            },

            scheduleClicked(element) {
                if(element.scheduleDays == -2)
                    return
                if(element.scheduleDays == -1) {
                    this.showTaskDialog(element)
                    return
                }
                this.makeTaskFromElement(element)
            },

            makeTaskFromElement(element) {
                let scheduleFor

                if(element.type == 'Date')
                    scheduleFor = element.value
                else if(element.type == 'Scheduler')
                    scheduleFor = DateHelpers.businessDaysFromNow(element.days).formatBackwards()
                else if(element.scheduleDays)
                    scheduleFor = DateHelpers.businessDaysFromNow(element.scheduleDays).formatBackwards()
                else
                    scheduleFor = DateHelpers.businessDaysFromNow(1).formatBackwards()

                let section = this.getElementSection(element, this.tabElements)

                this.$store.dispatch('saveTask', {
                    title: element.scheduleText || element.title,
                    tabKey: element.tabKey,
                    sectionKey: section ? section.key : null,
                    sectionTitle: section ? section.title : null,
                    due: scheduleFor,
                    lender: ElementHelpers.getValueFromName('lender')
                })
            },

            createAutomaticTasks(element) {
                if(!element.tasks || !element.tasks.length || !element.value)
                    return

                element.tasks.forEach(automaticTask => {

                    let section = this.getElementSection(element, this.tabElements)
                    const task = {
                        due: DateHelpers.businessDaysFromNow(automaticTask.days).formatBackwards(),
                        lender: ElementHelpers.getValueFromName('lender'),
                        sectionTitle: section ? section.title : null,
                        sectionKey: section ? section.key : null,
                        tabKey: element.tabKey,
                        title: automaticTask.title,
                        hint: `This automatic task was created by completing the '${element.title}' element`,
                    }

                    let assignee = this.contactElements.find(o => o.role == (automaticTask.role || 'NO-ROLE') )
                    if(assignee) {
                        task.assigned = {...assignee.contact, uid: assignee.contactKey}
                    }
                    this.saveTask(task)
                })
                AlertHelpers.showAlert(element.tasks.length + ' task/s created')
            },

            saveTask(task, settings) {
                this.$store.dispatch('saveTask', task)
            },

            addAfterElement(element) {
                let newOrder = OrderHelpers.orderKey()
                let nextElement = Utilities.arrayNextObject(element, this.tabElements)
                let thisOrder = element.order || 0

                if(nextElement) {
                    let nextOrder = nextElement.order
                    newOrder = parseInt((thisOrder + nextOrder) / 2)
                }
                this.editElement({
                    order: newOrder,
                    tabKey: element.tabKey,
                    width: 100,
                })
            },



            editElement(element) {
                let el = Object.assign({}, element)
                this.elementDialog.model = el
                this.elementDialog.settings.visible = true
            },

            createElement() {
                return {
                    transactionKey: this.transactionKey,
                    key: DataHelpers.getKey(),
                    order: OrderHelpers.orderKey(),
                    tabKey: this.tabKey || 'settings',
                    width: 100
                }
            },

            saveElement(element) {

                Utilities.log('saveElement', element)
                Utilities.removeUndefinedProperties(element)
                this.$store.dispatch('saveElement', element)
                // LogHelpers.log('element', this.$store.getters.tenantKey, this.transactionKey, element.key, element.value)
            },

            selectTab(tab, sectionName) {

                if(!tab) {
                    this.setSpecialTab('home')
                    return
                }

                //Should the important stuff be visible
                if(this.selectedTab && this.selectedTab.key == 'home')
                    this.importantVisible = false
                if(tab.key == 'home')
                    this.importantVisible = true

                // this.$store.commit('setSelectedTab', tab)
                this.$store.dispatch('selectTab', tab)      //in elements store

                //delay to allow tab to paint before loading elements into it...
                setTimeout( () => {

                    let destination = {
                        path: '/' + this.tenantKey + '/transaction/' + this.transactionKey
                    }



                    //Update Query parameters...
                    if(tab)
                        destination.query = {
                            tab: tab.key || tab
                        }

                    if(sectionName) {
                        destination.query.section = sectionName
                    }

                    setTimeout( () => {
                        this.scrollToElement(sectionName)
                    },(sectionName ? 500 : 0))


                    this.$router.replace(destination)

                    this.$store.dispatch('selectSection', null)

                    //Default element if one doesnt exist...

                    if(this.selectedTab && this.tabElements.length < 1) {
                        let element = this.createElement()
                        element.type = 'Section'
                        element.title = tab.title
                        this.saveElement(element)
                    }

                },10)

            },

            scrollToElement(section) {
                let parentElement = document.getElementById('col1') //see layoutcontainer

                let topPos = 0
                if(section) {
                    let sectionElement = this.$refs[section]
                    topPos = sectionElement[0].offsetTop
                    console.log('section jump', sectionElement)
                }

                parentElement.scrollTop = topPos - 135

            },

            elementClicked(element) {
                this.selectedElements = []
                let path = DataHelpers.getTransactionRef().toString() + `/elements/${element.key}`

                Utilities.log('elementClicked', element, path)

                let section = this.getElementSection(element, this.tabElements)

                if(element.type == 'Section' && section == this.selectedSection)
                    section = null
                this.$store.dispatch('selectSection', section)
            },

            elementDoubleClicked(element) {
                if(element.type == 'Section' || element.type == 'Outstanding') {
                    this.editElement(element)
                }
            },

            getElementSection(element, elements) {
                let idx = elements.findIndex(o => o.key == element.key)
                while(idx >= 0) {
                    let testingElement = elements[idx]
                    if(testingElement.type == 'Section'){
                        //Utilities.log('get Section returns ', testingElement.title)
                        return testingElement
                    }
                    idx --
                }
                return null
            },

            getElementsInSection(element, elements) {
                let section = this.getElementSection(element, elements)
                let idx = elements.findIndex(o => o.key == section.key)
                let result = [section]
                for(let n = idx + 1; n < elements.length; n++) {
                    let element = elements[n]
                    if(element.type != 'Section')
                        result.push(element)
                    else
                        break
                }
                return result
            },

            makeImportant(element) {
                element.important = true
                this.saveElement(element)
            },
            removeImportant(element) {
                element.important = false
                this.saveElement(element)
            },
            toggleNotApplicable(element) {
                element.na = !element.na
                this.saveElement(element)
                if(element.type == 'Section')
                    this.setNotApplicableSection(element)
            },

            setNotApplicableSection(sectionElement) {
                let sectionElements = this.getElementsInSection(sectionElement, this.tabElements)
                sectionElements.forEach(sec => {
                    sec.na = sectionElement.na
                    this.saveElement(sec)
                })
            },


            async deleteElements(elements) {
                if(await this.$root.$confirm('Delete', 'Delete these elements?', { color: 'red' }) == true) {
                     elements.forEach(element => {
                        this.deleteElement(element)
                    })
                }

                this.selectedElements = []
            },

            deleteElement(element) {
                this.$store.dispatch('deleteElement', element)
            },

            selectSingle(element) {
                Utilities.log('transaction > selectSingle')
                ListHelpers.selectSingle(element, this.elements)

                if(element.type == 'Section')
                    this.$store.dispatch('selectSection', element)
            },

            selectMulti(element) {
                if(element.type == 'Section') {
                    let sectionElements = this.getElementsInSection(element, this.tabElements)
                    this.selectedElements = sectionElements
                    return
                }

                let idx = this.selectedElements.findIndex(o => o.key == element.key)
                if(idx > -1)
                    this.selectedElements.splice(idx, 1)
                else
                    this.selectedElements.push(element)
            },

            isElementSelected(element) {
                return (this.selectedElements.findIndex(o => o.key == element.key) >= 0)
            },

            selectRange(element) {
                ListHelpers.selectRange(element, this.elements)
            },

            getElementStyle(element) {
                if(element.width == 10)
                        return 'width:10%'
                else if(element.width == 90)
                    return 'width:90%'
                else if(this.$vuetify.breakpoint.xsOnly)
                    return "width:100%"
                else
                    return "width:" + element.width + "%"
            },

            menuContainerStyle(element) {
                if(element.type == 'Lookup' && element.help )
                    return 'padding-top:20px;vertical-align:top'
                if(element.type=='Button')
                    return 'padding-bottom:12px;vertical-align:bottom;'
                else if(element.type=='Outstanding')
                    return 'padding-top:12px;vertical-align:top;'
                else if(element.type=='Checklist')
                    return 'padding-top:4px;vertical-align:top;'
                else
                    return 'padding-top:22px;vertical-align:top;'
            },

            // isTabLoaded(tab) {
            //     return (this.loadedTabs.indexOf(tab.key) > -1)
            // },

            add(prevElement) {
                let idx = this.elements.indexOf(prevElement)
                this.elements.splice(idx + 1, 0, this.makeRandomElement())
            },
            del(element) {
                let idx = this.elements.indexOf(element)
                Utilities.log('deleting...', idx)
                Utilities.log('deleting', idx)
                this.elements.splice(idx,1)
            },
            inc(element) {
                element.counter ++

            },

            reorderStep() {

            },

            async deleteAll() {

                if(this.isMaster) {
                    Utilities.log('Cant delete all in master')
                    return
                }
                if(await this.$root.$confirm('Delete', 'Delete everything from this file completely?', { color: 'red' }) == true) {

                   let elementCache = this.elements.map(o => {
                        return {'key': o.key}
                    })

                    elementCache.forEach(element => {
                        this.deleteElement(element)
                    })
                }
            },

            makeRandomElement() {
                let el = {
                    key: DataHelpers.getKey(),
                    title: 'Item number ' + NumberHelpers.randomInt(999).toString(),
                    showHint: NumberHelpers.randomInt(100) < 10,
                    important: NumberHelpers.randomInt(100) < 10,
                    width: ArrayHelpers.randomFromArray([50,30,10]),
                    counter: 0,
                    type: ArrayHelpers.randomFromArray(['Text', 'List', 'Switch','Checkbox', 'Section', 'Date', 'Currency'])
                }
                if(el.type == 'Section')
                    el.width=100
                if(el.type == 'List')
                    el.options = 'Item A, Item B, Item C'
                if(el.type == 'Status')
                    el.options = 'Item A|red, Item B|green, Item C|orange'
                return el

            },



            maintenance() {

                //old contacts...
                let oldContacts = this.elements.filter(o => (o.type == 'Contact' && o.tabKey))


                if(!oldContacts.length) {
                    console.log ('Skipping maintenance')
                    return
                }

                oldContacts.forEach(el => {

                    let uploadEl = {...el}
                    uploadEl.contact = null
                    uploadEl.contactKey = null
                    uploadEl.value = null
                    uploadEl.key = null
                    uploadEl['.key'] = null
                    uploadEl.title = 'Choose ' + uploadEl.title
                    uploadEl.name = StringHelpers.toSnakeCase(uploadEl.name) + '_selector'
                    uploadEl.type = "Contact Selector"
                    this.saveElement(uploadEl)

                    if(el.contact) {
                        el.width = null
                        el.tabKey = null
                        el.order = null
                        el.compact = null
                        this.saveElement(el)
                    } else
                        this.deleteElement(el)
                })

                AlertHelpers.showAlert('Performing contact maintenance')
            },

            checkForActions() {
                const action = this.$route.query.a
                if(action == 'email')
                    this.openWithEmail()
            },

            openWithEmail() {

                const role = this.$route.query.r
                const group = this.$route.query.g
                const template = this.$route.query.t
                if(!role || !group || !template) {
                    AlertHelpers.showAlert('Missing information to show Email')
                    return
                }

                //wait for auth....
                DataHelpers.fetchUser().then(user => {


                    this.sendTemplateEmail(role, group, template)
                })

            },

            test() {

            },

            initialise() {
                Utilities.log('transaction > Initialise')

                DataHelpers.initialiseTenant(this.tenantKey)

                this.$store.dispatch('loadTransaction', this.transactionKey).then((transaction) => {

                    //set page title to surname...
                    let arr = transaction.clients.split(' ')
                    document.title = arr[arr.length - 1]

                    Utilities.log('transaction > initialise - Calling load transaction', transaction)

                    this.$store.dispatch('loadAllElements').then(elementsResult => {
                        this.$store.dispatch('loadMaster').then(result => {
                            this.initialImport()
                        })

                        this.selectTab(this.tabs.find(o => o.key == this.$route.query.tab))

                        this.$store.dispatch('fetchAllGroups')

                        this.refreshTransactionClients()

                        this.checkForActions()

                        this.maintenance()

                        this.logTransactionView()

                        this.logOpenedAt()

                    })

                }).catch(err => {
                    AlertHelpers.showAlert(err)
                    this.transaction.clients = err
                    this.loading = false
                })
            },

            logOpenedAt() {
                this.clients.forEach(client => {

                    ContactHelpers.updateOpenedDate({
                        ...client,
                        tenantKey: this.tenantKey,
                    })
                })
            },

            refreshTransactionClients() {

                //pause to allow updating of client elements...

                setTimeout( () => {
                    let newClients = ContactHelpers.combineClientsNames(this.clients)
                    if(!newClients) {
                        if(this.isMaster)
                            AlertHelpers.showAlert('You are in the master template for your office. Please take care in here')
                        else
                            AlertHelpers.showAlert('Clients dont exist in this file. Please add them manually')
                        return
                    }
                    if(newClients == this.transaction.clients)
                        return

                    let newTransaction = {...this.transaction}
                    newTransaction.clients = newClients
                    this.$store.commit('setTransaction', newTransaction)

                    let ref = DataHelpers.getTransactionRef().child('details').child('clients')
                    ref.set(newClients)
                },1000)

            },

            makeTemplate() {
                TransactionHelpers.makeTemplate(this.transactionKey).then(result => {

                    window.location.reload()
                })
            },
            removeTemplate() {
                TransactionHelpers.removeTemplate(this.transactionKey).then(result => {

                    window.location.reload()
                })
            },
        },


        created() {
            this.initialise()

            setTimeout( () => {
                this.saveActiveStatusToMilestone()

            },3000)
        },

        mounted() {
            // setTimeout( () => {
            //     let els = document.querySelectorAll('.element')
            //     els.forEach(function(el) {

            //         el.addEventListener('click', function() { alert("clicked") })
            //     })
            // },100)
        },

        beforeDestroy() {
            document.title = 'Taco'
            PageHelpers.clearPageData()
        },

        watch: {
            'debugMode': {
                handler: function(newVal) {
                    console.log('debug mode set to ' + newVal)
                }

            }
        }


    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.vue-html5-editor {
    color: #888!important;
}

/* .vue-html5-editor>.toolbar {
    color: #ccc!important;
    border: solid 2px red;
} */

.element{
    padding-left:5px;padding-bottom:6px;
    border-radius:3px;
}

.element.compact {
    margin-top:-14px
}

.element.selected {
    border:dashed 1px #999;
    background-color: #ddd;
    margin: -1px -1px 0px 0px;
}

.element .menu-icon {
    color: transparent;
}

.menu-icon:focus {
    outline:0;
}

.element:hover .menu-icon, .element.selected .menu-icon {
    color: #999;
}

.element.important:hover .menu-icon {
    color:  #1c75d2!important;
}

.fast-text {
    width: 100%;
    padding: 5px 8px;
    border: solid 2px #bbb;
    border-radius: 2px;
}

.fast-label{
    font-size:0.9em;
    color: #777;
    margin-bottom: 3px;
    margin-left:2px;
}

.tab-bar {
    overflow-x:auto;
    background-color: #eee;
    margin:auto;
    max-width: 1280px;
}

.tab-container {
    margin-bottom:0px;display:flex;
}

.tab {
    height:40px;
    text-align: center;
    margin-top:8px;
    margin-left:-1px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 8px 12px;
    color: #888;
    border: solid 1px transparent;
    border-bottom: solid 1px #bbb;
    /* transition: all .4s ease-in-out; */
}

.tab.selected {
    border: solid 1px #bbb;
    border-bottom: solid 1px transparent;
    background-color: #fafafa;
}

.tab .tab-icon {
    color: #ccc;
}
.tab .tab-icon.complete {
    /* color: #FDD835 */
        color:  rgb(253, 239, 44);
        text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
}

.tab:hover {
    color:#444;
}

.tab .menu-icon {
    color: transparent;
}

.tab:hover .menu-icon {
    color: #bbb;
}

.add-icon {
    color: #bbb;
}

.add-icon:hover {
    color: #1c75d2
}

.flex-grid {
    display:flex;
    flex-wrap: wrap;
}

.clipboard {
    color: #999;
    padding:10px;
    border: solid 1px #999;
    border-radius:4px;
    background-color:#eee;
    margin-bottom:10px;
}

.text-button {
    margin-bottom:9px;color:#777;height:34px;
    border:solid 1px #ccc;border-radius:4px;padding:6px;
    padding-left:9px;display:inline-block;
    /* margin:-1px; */
}

.active-indicator {
    width:10px;height:10px;
    background-color: #21610B;
    border-radius: 50%;
}

.active-indicator.active {
    background-color: #01DF3A;
}




</style>


// WEBPACK FOOTER //
// Transaction.vue?2d021dfc